import './style.scss';
import { Button } from '@trufla-technology/trumarket-react-design-system';
import Credential from './Credential';
import {
  GenerateFtpCredentialsResponse,
  VerifyFtpCredentials,
} from '@trufla-technology/trufla-trudomain/dist/lib/truMarket/types';
import DeploymentDetails from './DeploymentDetails';

export type props = {
  ftpData: GenerateFtpCredentialsResponse['data'];
  ftpCredentials?: VerifyFtpCredentials;
  handleVerify: () => void;
  isVerified: boolean;
  isLoading: boolean;
  error: boolean;
};

const SiteCredentials = ({
  isVerified,
  ftpData,
  ftpCredentials,
  handleVerify,
  isLoading,
  error,
}: props) => {
  const getTheEnvFTPCredential = (env?: string) => {
    if (env === 'production' || env === 'staging' || env === 'development') {
      return ftpCredentials && ftpCredentials[env];
    }
  };

  return (
    <div className="details">
      <DeploymentDetails
        isVerified={isVerified}
        error={error}
        isLoading={isLoading}
      />
      <div className="environments">
        {ftpData?.map((item) => (
          <Credential
            key={item?.environment}
            environment={item?.environment}
            user={item?.ftpCredentials?.user}
            password={item?.ftpCredentials?.password}
            baseUrl={item?.ftpCredentials?.baseUrl}
            envFtpVerified={getTheEnvFTPCredential(item?.environment)}
            isLoading={isLoading}
          />
        ))}

        <Button
          type="primary"
          onClick={handleVerify}
          loading={isLoading}
          disabled={!isVerified}
        >
          Verify
        </Button>
      </div>
    </div>
  );
};
export default SiteCredentials;
